import moment from "moment";

type GridViewProps = {
  gridViewObject: any;
  editRecord: Function;
  confirmDeleteModal: Function;
  actionButtonFunction: Function;
};

function GridView(props: GridViewProps) {
  return (
    <table className="reuse-table">
      <thead>
        <tr>
          {props.gridViewObject.ColumnNames.map(
            (ColumnNames: any, index: any) => {
              if (ColumnNames.IsVisible) {
                return <th key={index}>{ColumnNames.Name}</th>;
              }
            }
          )}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {props.gridViewObject.GridData[0] &&
          props.gridViewObject.GridData[0].map((GridData: any, index: any) => (
            <tr key={index}>
              {props.gridViewObject.ColumnNames.map(
                (ColumnNames: any, c_index: any) => {
                  if (
                    ColumnNames.DataType !== "boolean" &&
                    ColumnNames.DataType !== "datetime" &&
                    ColumnNames.IsVisible
                  ) {
                    return (
                      <td key={c_index} className="text-left">
                        {GridData[ColumnNames.ActualColumnName]}
                      </td>
                    );
                  }
                  if (
                    ColumnNames.DataType === "boolean" &&
                    ColumnNames.IsVisible
                  ) {
                    return (
                      <td key={c_index} className="text-left">
                        {GridData[ColumnNames.ActualColumnName] === true
                          ? "true"
                          : "false"}
                      </td>
                    );
                  }
                  if (
                    ColumnNames.DataType === "datetime" &&
                    ColumnNames.IsVisible
                  ) {
                    return (
                      <td key={c_index} className="text-left">
                        {moment(GridData[ColumnNames.ActualColumnName]).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                    );
                  }
                }
              )}
              <td>
                <div className="flex-daj gap-10">
                  <a 
                    onClick={() =>
                      props.editRecord(GridData[props.gridViewObject.PKID])
                    }>
                    <img
                      src="images/edit.svg"
                      width="18px"
                      height="18px"
                      alt="Edit"
                    />
                  </a>
                  <a  onClick={() =>
                      props.confirmDeleteModal(
                        GridData[props.gridViewObject.PKID]
                      )
                    }>
                    <img
                      src="images/delete.png"
                      width="18px"
                      height="18px"
                      alt="Delete"
                    />
                  </a>
                </div>
              
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

//export default GridView;
export default GridView;
